import React, { useState } from 'react'
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { makeAjax, showMessage, url, respStatus } from '../../../../../helpers/global_helper';
// import BetSuccessPopup from '../Popups/BetSuccessPopup';
import QuickBuyPopup from './QuickBuyPopup';
import { withTranslation } from 'react-i18next';
import { getUserBalance, setCommonConfig } from "../../../../../redux/actions";
import { IoMdClose } from "react-icons/io";

// import ErrorPopup from "../Popups/ErrorPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";

const QuickBuyBetDetailsPopup = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const country_name = useSelector((state) => state.CommonConfig.country_name);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isTempError, setIsTempError] = useState({});
  const [isLoading, setIsLoading] = useState(false); // Track button loading state
  const [ReqData, setReqData] = useState({
    "gameId": null,
    "allowPartner": "allowPartner",
    "betTogelAuth": "betTogelAuth",
    "gameType": "quickbuy",
    "action": "save",
    'dataangka': []
  });
  const [inputValues, setInputValues] = useState({
    "gameId": gameId,
    "allowPartner": "allowPartner",
    "gameType": "quickbuy",
    'number': props.response.number,
  });

  const [SubmitRespData, setSubmitRespData] = useState([]);
  const { onClose } = props
  const totalSum = Object.values(props.response.totalBet).reduce((acc, val) => acc + val, 0);
  const [enterStatus, setEnterStatus] = useState(0);
  const hello = props.response.totalBet;

  const colokJituPosition = [{
    'As': ['A'],
    'Kop': ['B'],
    'Kepala': ['C'],
    'Ekor': ['D'],
  }][0];

  useEffect(() => {
    const dataangka = [];
    for (let key in props.response.dataBet) {
      if (props.response.dataBet.hasOwnProperty(key)) {
        const items = props.response.dataBet[key];
        items.forEach(item => {
          if (key === '4d3d2d' || key === 'colokbebas' || key === 'tengahtepi' || key === '50502d' || key === 'quick4d' || key === 'bbcampuran') {
            let amt = '';
            switch (key) {
              case '4d3d2d':
                amt = betDiscount.showMultipleNomor;
                break;
              case 'colokbebas':
                amt = betDiscount.showMultipleColokBebas;
                break;
              case 'tengahtepi':
                amt = betDiscount.showMultipleTengahTepi;
                break;
              case '50502d':
                amt = betDiscount.showMultiple50502d;
                break;
              case 'quick4d':
                amt = betDiscount.showMultipleNomor;
                break;
              case 'bbcampuran':
                amt = betDiscount.showMultipleNomor;
                break;
              default:
                break;
            }
            key = (key === 'quick4d' || key === 'bbcampuran') ? '4d3d2d' : key;
            dataangka.push([
              item.bet,
              item.betNo * amt,
              key,
              'success'
            ]);
          } else if (key === 'colokbebas2d') {
            dataangka.push([
              `${item.bet}${item.bet2}`,
              item.betNo * betDiscount.showMultipleColokBebas2d,
              key,
              'success'
            ]);
          } else if (key === 'coloknaga') {
            dataangka.push([
              `${item.bet}${item.bet2}${item.bet3}`,
              item.betNo * betDiscount.showMultipleColokNaga,
              key,
              'success'
            ]);
          } else if (key === 'colokjitu') {
            const positionData = colokJituPosition[item.position];
            dataangka.push([
              `${item.bet}-${positionData}`,
              item.betNo * betDiscount.showMultipleColokJitu,
              key,
              'success'
            ]);
          } else if (key === '5050') {
            dataangka.push([
              item.bet.replace(/\s+/g, '_').toLowerCase(),
              item.betNo * betDiscount.showMultiple5050,
              key,
              'success'
            ]);
          } else if (key === 'shio') {
            dataangka.push([
              parseInt(item.bet.split('.')[0], 10),
              item.betNo * betDiscount.showMultipleShio,
              key,
              'success'
            ]);
          } else if (key === 'kombinasi') {
            dataangka.push([
              `${item.bet.replace(/ /g, '-')}` + '+' + `${item.bet2.replace(/ /g, '-')}`,
              item.betNo * betDiscount.showMultipleKombinasi,
              key,
              'success'
            ]);
          } else if (key === 'silanghomo') {
            dataangka.push([
              `${item.bet.replace(/ /g, '-')}`,
              item.betNo * betDiscount.showMultipleSilangHomo,
              key,
              'success'
            ]);
          }
        });
      }
    }
    setReqData((prevState) => ({
      ...prevState,
      gameId: gameId,
      dataangka: dataangka
    }))
  }, []);

  const submitProcess = () => {
    // makeAjax(url.TOGEL_API.generateQuickBet, inputValues).then(response => {
    //   if (response.status !== respStatus["SUCCESS"]) {
    //     if (response.code === "sub_game_status_close") {
    //       dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
    //     }
    //     if (response.code === "market_close_err") {
    //       dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
    //     }
    //     showMessage(response);
    //     return;
    //   }

    // })
    setIsLoading(true); // Disable button

    makeAjax(url.TOGEL_API.processQuickBuy, ReqData).then(response => {
      if (response.status !== respStatus['SUCCESS']) {
        if (response.code == "insufficient_balance") {
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          setIsLoading(false); // Enable button after success
          return;
        }
        showMessage(response);
        setIsLoading(false); // Enable button after success
        return;
      }
      setSubmitRespData(prevData => [...prevData, response.data]);
      dispatch(getUserBalance());
      setEnterStatus(1);
      setSuccessPopup(true);
      setIsLoading(false); // Enable button after success

    });
  }

  const handleClose = () => {
    setSuccessPopup(false);
    props.onClose();
    props.onReset();
  }

  const { dataBet } = props.response;

  useEffect(() => {
    const { tempdatabeterror } = props.response;
    if (tempdatabeterror) {
      setIsTempError(tempdatabeterror);
    }
  });

  let rowIndex = 0; // Counter for rows with non-zero values

  const headerMappings = {
    '4d3d2d': ['4D/3D/2D'],
    'colokbebas': ['Colok Bebas'],
    'colokbebas2d': ['Colok Bebas 2D'],
    'colokjitu': ['Colok Jitu'],
    'coloknaga': ['Colok Naga'],
    '5050': ['50-50'],
    '50502d': ['50-50 2D'],
    'macaushio': ['Macau Shio'],
    'shio': ['Shio'],
    'tengahtepi': ['Tengah / Tepi'],
    'kombinasi': ['Kombinasi'],
    'quick4d': ['Quick Bet 4D'],
    'bbcampuran': ['BB Campuran'],
    'silanghomo': ['Silang Homo'],
  };

  const renderTable = (title, data) => {
    const header = headerMappings[title] || Object.keys(data[0] || {});
    return (
      <div className="table-container" style={{ width: "100%" }}>
        <h2 className="quickbut_txt">{header}</h2>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>#</th>
              {Object.keys(data[0] || {}).map((key) => (
                <th key={key} >{key === 'betNo' ? props.t('amount') : key}</th>
              ))}
            </tr>
          </thead>
          <tbody >
            {data.map((row, index) => (
              <tr key={index}
                className={index % 2 === 0 ? "even-row" : "odd-row"}>
                <td>{index + 1}</td>
                {Object.values(row).map((value, index) => (
                  <td key={index}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (enterStatus == 0) {
        if (event.key === "Enter") {
          setEnterStatus(1);
          event.preventDefault();
          submitProcess();
        }
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [submitProcess]);

  return (
    <div className="overlay">
      <div className='overlay_innerDiv' onClick={onClose}></div>
      <div className="informasi_popup quickbuy_betdetail_popup">
        <button className="informasi_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose" />
        </button>
        {props.response.betGenerated == '' && (
          <>
            <div className="details_txt">Detail Bet (QUICK BUY - {country_name})</div>
            <div className='quickbuy_betdetail_container' style={{marginTop: 15}}>
              <div className="betdetails_container" >
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      
                      <th colSpan={2}>{props.t('bet_details')}</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr>
                      <td className="total_txt">Total</td>
                      <td className="toal_no">0</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className='quickbuy_betdetail_container'>
              <div className='betdetails_container'>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{ color: "#e33e3e" }}>{props.t('incomplete_format')}</th>
                    </tr>
                  </thead>
                  <tbody >
                    <tr>
                      <td style={{padding: "10px 5px"}}>{props.response.number}</td>
                    </tr>
                  </tbody>
                </table>
                <p className="note" style={{fontSize: 14,textAlign: "left", padding: 0}}>Note: {props.t('quickbuy_note')}</p>
              </div>
            </div>

          </>

        )}

        {props.response.betGenerated !== '' && (
          <>
            <div className="details_txt">Detail Bet  &nbsp; <span style={{ textTransform: "uppercase" }}>(QUICK BUY - {country_name})</span> </div>
            <div className="quickbuy_betdetail_container">
              <div className='betdetails_container'>
                {Object.keys(dataBet).map((key) => {
                  const data = dataBet[key];
                  if (data.length > 0) {
                    return renderTable(key, data);
                  }
                  return null;
                })}
              </div>
            </div>
            <div className="quickbuy_betdetail_container">
              <div className='betdetails_container'>
                <table>
                  <thead>
                    <tr className="Heading">
                      <th colSpan={3}>{props.t('bet_details')}</th>

                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(props.response.totalBet).map((key, index) => (

                      props.response.totalBet[key] > 0 && ( // Conditional check

                        // <tr key={index} className={displayIndex % 2 === 0 ? "even-row" : "odd-row"}>
                        <tr
                          key={key}
                          className={
                            props.response.totalBet[key] > 0
                              ? rowIndex++ % 2 === 0
                                ? "even-row"
                                : "odd-row"
                              : ""
                          }
                          style={{ display: props.response.totalBet[key] > 0 ? "table-row" : "none" }} // Hide rows with zero values
                        >
                          <td style={{ width: "50%" }} >{headerMappings[key] || key.toUpperCase()}</td>
                          <td style={{ width: "50%" }} colSpan="2">{props.response.totalBet[key]}</td>

                        </tr>
                      )

                      // <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                      //   <td style={{ width: "10%" }}>{headerMappings[key] || key.toUpperCase()}</td>
                      //   <td style={{ width: "70%" }}>&nbsp;</td>
                      //   <td style={{ width: "10%" }}>{props.response.totalBet[key]}</td>
                      // </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="odd-row" style={{ borderTop: "1px solid #beb5b5" }}>
                      <td colSpan="1" >Total</td>
                      <td >{totalSum}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            {props.validate && <div>Error</div>}
            {isTempError && Object.keys(isTempError).length > 0 && (
              <div className="quickbuy_betdetail_container">
                <div className='betdetails_container'>
                  <table>
                    <thead>
                      <tr className="Heading">
                        <th style={{ color: "#e33e3e" }}>{props.t('incomplete_bet')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(isTempError).map(([key, value], index) => (
                        <tr key={index}>
                          <td>{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>{props.t('incomplete_bet_note')}</p>
                </div>
              </div>
            )}
            <div className='btn_section'>
              <ul className="button-list">
                <li>
                  <button
                    className="reset"
                    onClick={onClose}
                  // onClick={() => {
                  //   onClose();
                  //   // handleSecondClick();
                  //   setIsTempError({});
                  //   setSubmitRespData([]);
                  // }}
                  >No</button>
                </li>
                <li>
                  <button className="submit" disabled={isLoading} onClose={onclose} onClick={submitProcess}>Yes</button>
                </li>
              </ul>
            </div>
          </>
        )}

        {successPopup && (
          <div className="popup-overlay ">
            <QuickBuyPopup onClose={handleClose} response={SubmitRespData} />
          </div>
        )}
        {
          /*---error popup --*/
          showErrorPopup && (
            <ErrorInnerPopup
              modalTitle={""}
              modalHeader={true}
              onCloseModal={() => setShowErrorPopup(false)}
            >
              <ErrorPopup
                message={errMessage}
                onClose={() => {
                  setShowErrorPopup(false);
                  setIsDisabled(false);
                }}
              />
            </ErrorInnerPopup>
          )
        }
      </div>
    </div>
  );
};

export default withTranslation()(QuickBuyBetDetailsPopup);
